import { render, staticRenderFns } from "./AddTypographyModal.vue?vue&type=template&id=6c5bfffc&scoped=true"
import script from "./AddTypographyModal.vue?vue&type=script&lang=js"
export * from "./AddTypographyModal.vue?vue&type=script&lang=js"
import style0 from "./AddTypographyModal.vue?vue&type=style&index=0&id=6c5bfffc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5bfffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c5bfffc')) {
      api.createRecord('6c5bfffc', component.options)
    } else {
      api.reload('6c5bfffc', component.options)
    }
    module.hot.accept("./AddTypographyModal.vue?vue&type=template&id=6c5bfffc&scoped=true", function () {
      api.rerender('6c5bfffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Settings/AddTypographyModal.vue"
export default component.exports